import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ExploreCreators from '../components/explore/ExploreCreators';
import CreatorProfile from '../components/explore/CreatorProfile';

const Explore = () => {
  return (
    <Routes>
      <Route index element={<ExploreCreators />} /> 
    </Routes>
  );
};

export default Explore;